import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'celsiusToFahrenheit',
    standalone: false
})
export class CelsiusToFahrenheitPipe implements PipeTransform {
  transform(value: number, shouldConvert = true): string {
    if (shouldConvert) {
      const fahrenheit = value * (9 / 5) + 32;
      const rounded = Math.round(fahrenheit * 10) / 10;
      if (rounded === Math.floor(rounded)) {
        return rounded.toFixed(0);
      }
      return rounded.toFixed(1);
    } else {
      return value.toString();
    }
  }
}
